export default __webpack_public_path__ + "static/media/ddsu5168_2p_blue_rs485_master_4p.4b100a5c.png";